var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoney = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#004B87",
    fillRule: "evenodd",
    stroke: "#004B87",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.193 2.014c-9.474 0-17.182 7.622-17.182 16.992 0 9.369 7.708 16.991 17.182 16.991 9.474 0 17.182-7.622 17.182-16.991 0-9.37-7.708-16.992-17.182-16.992m0 34.983C9.162 36.997 1 28.926 1 19.006S9.162 1.014 19.193 1.014s18.193 8.071 18.193 17.992c0 9.92-8.162 17.991-18.193 17.991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.745 29.21c-.251 0-.455-.22-.455-.493V9.683c0-.273.204-.493.455-.493s.455.22.455.493v19.034c0 .272-.204.493-.455.493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.745 26.48c-2.258 0-4.095-1.847-4.095-4.117a.498.498 0 1 1 .994 0c0 1.72 1.391 3.117 3.101 3.117s3.1-1.398 3.1-3.117c0-1.72-1.39-3.119-3.1-3.119-2.258 0-4.095-1.846-4.095-4.117 0-2.27 1.837-4.117 4.095-4.117s4.095 1.847 4.095 4.117a.498.498 0 1 1-.994 0c0-1.72-1.391-3.117-3.101-3.117s-3.1 1.398-3.1 3.117c0 1.72 1.39 3.118 3.1 3.118 2.258 0 4.095 1.847 4.095 4.118 0 2.27-1.837 4.117-4.095 4.117"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoney);
export default ForwardRef;